export default {
  'nav.brand': 'AllChinaBuy Spreadsheet',
  'nav.categories': 'Kategorien',
  'nav.guides': 'Guides',
  'nav.faq': 'FAQ',
  'nav.explore': 'Spreadsheet entdecken',
  'nav.home': 'Start',
  'nav.shoppingGuide': 'Einkaufsguide',
  'nav.sheetCta': 'AllChinaBuy Sheet',

  'hero.badge': 'WÖCHENTLICH AKTUALISIERT · AUSGABE 2026',
  'hero.title': 'Das vollständigste AllChinaBuy Spreadsheet-Verzeichnis',
  'hero.titlePre': 'Das vollständigste',
  'hero.titleHighlight': 'AllChinaBuy Spreadsheet',
  'hero.titleSuffix': 'Verzeichnis',
  'hero.subtitle': 'Entdecke Tausende kuratierte Produktfunde in den Bereichen Schuhe, Kleidung, Taschen, Accessoires und mehr. Wöchentlich aktualisiert mit qualitätsgeprüften Angeboten und übersichtlichen Kategorien für clevere Käufer.',
  'hero.cta1': 'AllChinaBuy Sheet',
  'hero.cta2': 'Jetzt kaufen',
  'hero.trust1': 'Wöchentlich aktualisiert',
  'hero.trust2': 'Qualitätsgeprüft',
  'hero.trust3': 'Verifiziert',

  'trust.independent': 'Unabhängige Ressource',
  'trust.research': 'Recherche-fokussiert',
  'trust.updated': 'Regelmäßig aktualisiert',

  'selector.title': 'Nach Kategorie durchsuchen',
  'selector.placeholder': 'Kategorie auswählen…',
  'selector.all': 'Alle Kategorien',

  'categories.title': 'Beliebte Kategorien',
  'categories.badge': 'KURATIERT',
  'categories.intro': 'Stöbere durch unsere sorgfältig organisierte Sammlung von AllChinaBuy-Spreadsheets. Jede Kategorie verlinkt direkt auf verifizierte Produktangebote in unserem Hauptshop.',
  'categories.subtitle': 'Wähle eine Kategorie, um passende Produkte auf der Hauptseite zu entdecken.',
  'categories.browse': 'Diese Kategorie ansehen',

  'features.title': 'Warum ein Spreadsheet für die Produktrecherche nutzen?',
  'feature1.title': 'Alles an einem Ort',
  'feature1.desc': 'Durchsuche Schuhe, Kleidung, Taschen und mehr in einem organisierten Hub statt auf vielen Seiten.',
  'feature2.title': 'Klare Kategorien',
  'feature2.desc': 'Springe direkt zur gewünschten Kategorie — per Dropdown oder mit einem Klick.',
  'feature3.title': 'Unabhängig & ehrlich',
  'feature3.desc': 'Eine unabhängige, auf Entdeckung fokussierte Ressource ohne gefälschte Bewertungen, Preise oder Coupons.',

  'guide.title': 'Was ist das AllChinaBuy Spreadsheet?',
  'guide.p1': 'Ein AllChinaBuy-Spreadsheet ist eine organisierte Möglichkeit, Produktfunde zu durchstöbern. Es bündelt beliebte Artikel in klaren Kategorien — Schuhe, Hoodies, T-Shirts, Jacken, Hosen, Accessoires und mehr — damit du Produkte schnell entdeckst und smarter einkaufst.',
  'guide.p2': 'Statt Seite für Seite zu suchen, kannst du über die obigen Kategorien direkt zum gewünschten Bereich springen. Jeder Link führt dich zur passenden Kategorie auf der Hauptseite.',
  'guide.p3': 'Dies ist eine unabhängige Ressource rund um die Produktentdeckung. Wir setzen auf hilfreiche, originelle Inhalte — ohne gefälschte Bewertungen, Preise oder Coupons — damit du immer weißt, worum es geht.',
  'guide.readMore': 'Kompletten Guide lesen',
  'guide.readMoreSub': 'Erfahre, wie du das Spreadsheet für die Produktrecherche nutzt — mit praktischen Tipps und FAQ.',

  'companion.badge': 'Über AllChinaBuy Sheet',
  'companion.title': 'Dein ultimativer Einkaufsbegleiter',
  'companion.p1': 'Das <strong>AllChinaBuy-Spreadsheet</strong> ist für Tausende clevere Käufer weltweit zu einem unverzichtbaren Werkzeug geworden. Ob du auf der Jagd nach den neuesten Sneaker-Releases, Premium-Streetwear oder versteckten Luxus-Schätzen bist — ein gut organisiertes <strong>Produktverzeichnis</strong> kann dir stundenlanges Suchen ersparen und dir helfen, Produkte zu entdecken, die du allein nie finden würdest.',
  'companion.p2': 'Unser <strong>AllChinaBuy-Spreadsheet-2026</strong>-Verzeichnis vereint die umfassendste Sammlung verifizierter Funde — von Nike- und Jordan-Sneakern über Essentials-Hoodies bis hin zu Chrome-Hearts-Accessoires und allem dazwischen. Jedes Spreadsheet wird regelmäßig aktualisiert, damit du immer Zugriff auf die frischesten Drops und die preiswertesten Artikel hast.',
  'companion.p3': 'Was unser Verzeichnis auszeichnet, ist der Grad der Kuration. Wir listen nicht einfach jedes Spreadsheet auf, das uns begegnet. Jeder Eintrag in unserer <strong>AllChinaBuy-Spreadsheet</strong>-Sammlung wird manuell auf Qualität, Genauigkeit und Relevanz geprüft. So verbringst du weniger Zeit mit toten Links und mehr Zeit damit, genau das zu finden, was du möchtest.',
  'companion.cta1': 'Hauptshop besuchen',
  'companion.cta2': 'Kompletten Guide lesen',

  'why.badge': 'WARUM WIR',
  'why.title': 'Das Vertrauen Tausender Käufer',
  'why.subtitle': 'Unser AllChinaBuy-Spreadsheet-Verzeichnis basiert auf Zuverlässigkeit, Aktualität und echtem Nutzerfeedback — hier erfährst du, was es zur bevorzugten Ressource cleverer Käufer im Jahr 2026 macht.',
  'why.f1.title': 'Wöchentlich aktualisiert',
  'why.f1.desc': 'Unser Verzeichnis wird jede Woche mit den neuesten Funden aktualisiert, damit du keinen neuen Drop oder Trendartikel verpasst.',
  'why.f2.title': 'Qualität verifiziert',
  'why.f2.desc': 'Jedes Spreadsheet wird vor der Aufnahme manuell geprüft. Wir kontrollieren tote Links, veraltete Preise und ungenaue Produktbeschreibungen.',
  'why.f3.title': 'Organisierte Kategorien',
  'why.f3.desc': 'Stöbere durch 14 sorgfältig organisierte Kategorien — von Sneakern und Hoodies bis zu Accessoires und Düften — und finde in Sekunden genau das Richtige.',
  'why.f4.title': 'Schnelle Navigation',
  'why.f4.desc': 'Direkte Links zu verifizierten Produktangeboten in unserem Hauptshop nehmen dir das Rätselraten ab und bringen dich schneller als je zuvor vom Stöbern zum Kauf.',
  'why.f5.title': 'Vergleichsguides',
  'why.f5.desc': 'Direkte Vergleiche helfen dir, verschiedene Spreadsheet-Optionen, Preisstufen und Agenten-Empfehlungen zu bewerten, bevor du dich festlegst.',
  'why.f6.title': 'Neueste Funde',
  'why.f6.desc': 'Bleib Trends voraus mit frühzeitigem Zugang zu neu entdeckten Schätzen, limitierten Releases und unauffälligen Schnäppchen in allen Kategorien.',

  'faq.title': 'Häufig gestellte Fragen',
  'faq.subtitle': 'Alles, was du über AllChinaBuy-Spreadsheets wissen musst, wie sie funktionieren und wie du das Beste aus unserem Verzeichnis herausholst.',
  'faq.q1': 'Ist dies eine offizielle AllChinaBuy-Website?',
  'faq.a1': 'Nein, dies ist eine unabhängige Informationsressource und wird nicht von AllChinaBuy betrieben.',
  'faq.q2': 'Wo kann ich die Produkte kaufen?',
  'faq.a2': 'Alle Kategorielinks führen dich zur Hauptseite, wo du vollständige Angebote durchstöbern und einkaufen kannst.',
  'faq.q3': 'Ist das Spreadsheet kostenlos?',
  'faq.a3': 'Ja, das Durchstöbern von Kategorien und Guides ist hier völlig kostenlos.',
  'faq.q4': 'Wie finde ich einen bestimmten Artikel?',
  'faq.a4': 'Wähle die passende Kategorie im Dropdown oder über die Buttons und durchsuche dann die verlinkten Angebote.',
  'faq.q5': 'Wie oft werden die Spreadsheets aktualisiert?',
  'faq.a5': 'Wir bemühen uns, Kategorien und Guides aktuell zu halten. Schau regelmäßig vorbei für die neuesten Funde und Tipps.',
  'faq.q6': 'Kann ich mein eigenes Spreadsheet einreichen?',
  'faq.a6': 'Derzeit akzeptieren wir keine Benutzereinreichungen. Alle Einträge werden von unserem Redaktionsteam manuell kuratiert.',

  'cta.title': 'Bereit, das AllChinaBuy Spreadsheet zu entdecken?',
  'cta.subtitle': 'Stöbere durch Kategorien und Produktfunde oder gehe direkt zur Hauptseite.',
  'cta.button1': 'AllChinaBuy Spreadsheet',
  'cta.button2': 'Jetzt kaufen',

  'finalcta.title': 'Bereit für dein nächstes Schnäppchen?',
  'finalcta.subtitle': 'Schließe dich Tausenden cleverer Käufer an, die bereits unser AllChinaBuy-Spreadsheet-Verzeichnis nutzen. Wöchentlich aktualisiert mit den neuesten verifizierten Funden in 14 Kategorien.',
  'finalcta.button1': 'Spreadsheets durchstöbern',
  'finalcta.button2': 'Guide lesen',

  'guides.badge': 'Einkaufsguides',
  'guides.title': 'AllChinaBuy Einkaufsguides',
  'guides.subtitle': 'Ausführliche, originale Guides, um Produkte zu recherchieren, sicher zu bestellen und smarter zu versenden.',

  'footer.description': 'Ein unabhängiger Ressourcen-Hub für AllChinaBuy-Produktfunde, Kategorien und Kaufguides.',
  'footer.tagline': 'Speichere unsere Seite als Lesezeichen und schau jede Woche vorbei für die neuesten AllChinaBuy-Spreadsheet-Updates, neue Kategorien und frische Funde in allen 14 Kategorien.',
  'footer.readGuide': 'Kompletten Guide lesen',
  'footer.popularCategories': 'Beliebte Kategorien',
  'footer.quickLinks': 'Schnelllinks',
  'footer.mainStore': 'Hauptshop — AllChinaBuy Sheet',
  'footer.buyNow': 'Jetzt kaufen',
  'footer.completeGuide': 'Kompletter Guide 2026',
  'footer.allCategories': 'Alle Kategorien',
  'footer.faq': 'FAQ',
  'footer.home': 'Start',
  'footer.mainStoreShort': 'Hauptshop',
  'footer.copyright': 'Alle Rechte vorbehalten. Nicht mit AllChinaBuy verbunden.',
  'footer.categoriesLink': 'Kategorien',
  'footer.guideLink': 'Kaufguide',
  'footer.faqLink': 'FAQ',
  'footer.disclaimer': 'Dies ist eine unabhängige Informationsressource und wird nicht von AllChinaBuy betrieben.',
  'footer.rights': 'Alle Rechte vorbehalten.',
  'footer.externalNote': 'Links zur Hauptseite öffnen in einem neuen Tab.',

  'categories.shoes': 'Schuhe',
  'categories.hoodies': 'Hoodies / Sweatshirts',
  'categories.tshirts': 'T-Shirts',
  'categories.jackets': 'Jacken',
  'categories.pants': 'Hosen / Shorts',
  'categories.headwear': 'Kopfbedeckung',
  'categories.sets': 'Sets',
  'categories.underwear': 'Unterwäsche',
  'categories.jersey': 'Trikots',
  'categories.accessories': 'Accessoires',
  'categories.bags': 'Taschen',
  'categories.belts': 'Gürtel',
  'categories.perfumes': 'Parfüms',
  'categories.other': 'Sonstiges',
};